<template>
  <MapTab key="mapTabPub" target="pub" />
</template>

<script>
import MapTab from "@/components/map/MapTab.vue";

export default {
  name: "MapTabFav",
  components: {MapTab},
};
</script>
